module.exports = __webpack_public_path__ + "static/media/money.2df4dca4.svg";